export default __webpack_public_path__ + "static/media/dgl-laptop.cfe6786a.png";